// Suspense fallback for route-level code-splitting. The route pages are
// React.lazy(), so the first visit to a route's chunk suspends while the chunk
// downloads; this fills ONLY the layout's content slot (it's rendered inside the
// layout's <Outlet/> Suspense, never around the whole screen) so the sidebar and
// the rest of the chrome stay put — the page area shows a quiet, token-only
// placeholder instead of blanking. Once a chunk is cached, revisits don't
// suspend, so this never interferes with in-page state (pagination, team scope).
export const RouteFallback = () => {
  return (
    <div className="flex min-h-[40vh] items-center justify-center">
      <span className="animate-pulse text-sm text-gruvbox-gray">···</span>
    </div>
  );
};
